export const reseller = {
    id: null,
    lat: null,
    lng: null,
    name: null,
    email: null,
    phone: null,
    status: null,
    address_id: null,
    address: {
        id: null,
        city: null,
        label: null,
        state: null,
        address: null,
        country: null,
        zipcode: null,
        address2: null,
        district: null,
    },
    social_medias: {
        facebook: null,
        instagram: null,
    },
    site: null,
};

export const lead = {
    id: null,
    name: null,
    role: '',
    city: null,
    email: null,
    state: '',
    phone: null,
    status: null,
    country: null,
    zipcode: null,
    contact_by: '',
    newsletter: true,
    reseller_id: null,
    acceptance: null,
    visited_product: null,
};